const KEY_STORAGE = {
    ID_TOKEN: 'id_token',
    URL_REDIRECT: 'url_redirect',
    EXPIRES_IN: 'expires_in',
    PROFILE: 'profile',
};
export default KEY_STORAGE;
